import {
  SvgIcon as MuiSvgIcon,
  SvgIconProps as MuiSvgIconProps,
} from "@mui/material";

export const WarningIcon = (props: MuiSvgIconProps) => (
  <MuiSvgIcon {...props} data-testid="warning-icon">
    <path d="M1.86719 20.5L12.0017 3L22.1362 20.5H1.86719ZM4.45169 19H19.5517L12.0017 6L4.45169 19ZM12.0017 17.8077C12.2305 17.8077 12.4224 17.7303 12.5772 17.5755C12.732 17.4207 12.8094 17.2288 12.8094 17C12.8094 16.7712 12.732 16.5793 12.5772 16.4245C12.4224 16.2697 12.2305 16.1923 12.0017 16.1923C11.7729 16.1923 11.581 16.2697 11.4262 16.4245C11.2714 16.5793 11.1939 16.7712 11.1939 17C11.1939 17.2288 11.2714 17.4207 11.4262 17.5755C11.581 17.7303 11.7729 17.8077 12.0017 17.8077ZM11.2517 15.1923H12.7517V10.1923H11.2517V15.1923Z" fill="var(--gravx-color-utility-warning-on-light-text)" />
  </MuiSvgIcon>
);
